<template>
  <div class="content-container">
    <!-- Lewy panel – nawigacja/filtrowanie (obecnie pusty, zostawiony na przyszłość) -->
    <div class="filters-container"></div>
    
    <div class="content-wrap">
      <!-- Pasek górnego menu -->
      <TopMenu />
    </div>
  </div>
  <!-- Komponent ze szczegółami pojazdu.
       Przekazuje do VehicleDetails:
         - czy licznik czasu ma być widoczny (timer-visible)
         - dane pojazdu (vehicle) z lokalnego stanu komponentu -->
  <VehicleDetails :timer-visible="$route.meta.timerVisible" :vehicle="vehicle" />
</template>

<script>
import TopMenu from "../components/TopMenu.vue";
import VehicleDetails from "@/components/VehicleDetails";

export default {
  name: "VehicleDetailsView",
  components: {
    VehicleDetails,
    TopMenu,
  },
  methods: {
    // Funkcja pomocnicza – sprawdza czy jest dostępna historia przeglądarki do cofnięcia
    hasHistory() {
      return window.history.length > 1;
    },
  },
  created() {
    // Próba pobrania pojazdu z historii nawigacji (np. przekazany przez router-link z parametrem :state)
    const vehicle = history.state?.vehicle;
    if (vehicle) {
      this.vehicle = vehicle;
    }
  },
  data() {
    return {
      // Domyślnie nie ma pojazdu – czeka na wypełnienie przez created()
      vehicle: null,
    };
  },
};
</script>

<style scoped>
/* Lewy panel (tło pod filtry) */
.filters-container {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}

/* Dostosowanie wysokości wrapa do zawartości */
.content-container .content-wrap,
.content-container > div {
  min-height: auto;
}
</style>
